import css from 'styled-jsx/css';

const styles = css.global`.rotoql-content-error__container{min-height:100vh;display:flex;justify-content:center;align-items:center}.rotoql-content-error__text-container{text-align:center}.rotoql-content-error__title{font-size:20px;font-weight:500;line-height:1.4;color:#262626;margin-bottom:20px}@media(min-width: 768px){.rotoql-content-error__title{font-size:40px;line-height:normal}}`;

export default styles;